export default __webpack_public_path__ + "static/media/trovowebpage.fba78b38.png";